import HistogramRanking from './HistogramRanking';
import './HistogramRanking.scss';

export default HistogramRanking;
